module.exports = __webpack_public_path__ + "img/movemini.e9e0bba1.png";